module.exports = __webpack_public_path__ + "img/men.9d4c13d2.png";